export default __webpack_public_path__ + "static/media/condopark_bg.ab2c3abd.svg";